import mapboxgl from 'mapbox-gl'
import Dropzone from 'dropzone'

I18n.defaultLocale = "fr";

mapboxgl.accessToken = "pk.eyJ1Ijoia29jaGthIiwiYSI6ImNqdTJ3OXAzcTBmZGczeW1ud3I0ajJxd2gifQ.zDkUNU8_hB0URYwL70jIBQ";

Dropzone.autoDiscover = false;
